import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from './Modal';
import ProfileFinisherForm from './ProfileFinisherForm';
import { useAuth } from '../context/AuthContext';

function hasGoogleProvider(user) {
  return Boolean(user?.providerData?.some((provider) => provider?.providerId === 'google.com'));
}

function GoogleProfileFinisherGate() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, userDoc, loading } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(false);
  }, [user?.uid]);

  const profileCompleted = Boolean(userDoc?.googleProfileCompletedAt);

  useEffect(() => {
    if (profileCompleted) {
      setDismissed(false);
    }
  }, [profileCompleted]);

  if (loading || !user || !userDoc) return null;

  const onAuthPages = location.pathname === '/login' || location.pathname === '/signup';
  const onCompleteProfilePage = location.pathname === '/complete-profile';
  const isGoogleUser = hasGoogleProvider(user);

  const shouldShow = isGoogleUser && !profileCompleted && !dismissed && !onAuthPages && !onCompleteProfilePage;

  if (!shouldShow) return null;

  return (
    <Modal
      isOpen={true}
      title="Finish Your Profile"
      hideFooter={true}
    >
      <ProfileFinisherForm
        source="google"
        submitLabel="Next"
        showSkip={false}
        className="complete-profile-shell--modal"
        onComplete={() => {
          setDismissed(true);
          navigate('/feed', { replace: true });
        }}
      />
    </Modal>
  );
}

export default GoogleProfileFinisherGate;
